export default "__VITE_ASSET__DykzztIy__"